import CoursesContent from "../../components/others/courses/CoursesContent";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../../helpers/SeoHelper";
import {useState} from "react";
import {kSystemIcons} from "../../constants/icons";
import SystemAppScreenHeader from "../../components/headers/SystemAppScreenHeader";
import CoursesScreenInfoDialog from "../../components/dialogs/courses/CoursesScreenInfoDialog";

export default function CoursesScreen({ selectedGrade,
                                        setFlashGrade }) {
    // Used in MetaCoursesScreen for the user to select LevelAs through
    // Subthemes

    // PROPERTIES
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)

    // BUILD
    return (
        <div className="overflow-auto w-full h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center">
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Cours et exercices')}</title>
                <meta name="description"
                      content="Explications et exercices pour maitriser chaque savoir-faire fondamental du collège." />
            </Helmet>
            {/** MODAL */}
            <CoursesScreenInfoDialog open={isInfoModalOpen}
                                    handleClose={processModalClosing} />
            {/** CONTENT */}
            <div className={"animate-appearSlow grow w-full flex flex-col justify-start items-center min-h-0"}>
                <div className={"w-full p-[16px]"}>
                    <SystemAppScreenHeader title={"Cours et exercices"}
                                           icon={kSystemIcons.book}
                                           onInfoClick={processModalOpening}
                                           isBrevetDisplay={false} />
                </div>
                <CoursesContent setFlashGrade={setFlashGrade}
                                selectedGrade={selectedGrade} />
            </div>
        </div>
    );

    // METHODS
    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isInfoModalOpen) {
            setIsInfoModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isInfoModalOpen) {
            setIsInfoModalOpen(false)
        }
    }
}
